import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import * as R from 'ramda';
import PageLoader from '../../../../../../components/PageLoader';
import AgentComponent from '../components/agent.component';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountTypesListItems } from '../../../../../../redux/account-types/selector';
import { accountTypes } from '../../../../../../redux/account-types/action';
import { toast } from 'react-toastify';
import { agents } from '../../../../../../redux/agents/action';
import { selectAgentsListItems, selectAgentsQueryItems } from '../../../../../../redux/agents/selector';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { vehicles } from '../../../../../../redux/vehicles/action';
import { selectVehiclesListItems } from '../../../../../../redux/vehicles/selector';
import { orders } from '../../../../../../redux/orders/action';
import { selectOrdersListItems } from '../../../../../../redux/orders/selector';

const ManagementAgent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const accountItems = useSelector(selectAccountsListItems)
    const vehicleItems = useSelector(selectVehiclesListItems)
    const salesOrderItems = useSelector(selectOrdersListItems)
    const transportAgentItems = useSelector(selectAgentsListItems)
    const AgentQuery = useSelector(selectAgentsQueryItems)
    const [
        selectedAgents,
        setSelectedAgents
    ] = useState<any>([])

    const [
        selectedAccounts,
        setSelectedAccounts
    ] = useState<any>({
        LoginInfo: {},
        UserInfo: {},
        AccountInfo: {
            IsPersonAccount: true,
            IsCustomerPortalEnabled: false,
            IsVendorPortalEnabled: false,
            IsPartnerEnabled: false,
            IsAccountVerified: true,
            IsGuestAccessEnabled: true,
            IsLimitedToOrganizationUnit: false,
            EnableOnNetworkLogisticsSupport: true,
            MappedAccountTypes: {}
        },
        AccountAddress: {},
        PrimaryAddress: {}

    })
    const fetchAgentQueryById = () => {
        dispatch(agents.query({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/query`, entity: 'agents', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedAccounts({ ...selectedAccounts, [fields[0]]: value });
        setSelectedAgents({ ...selectedAgents, [fields[0]]: value });
    }


    useEffect(
        () => {
            dispatch(accountTypes.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`, entity: 'accountTypes', jsonData: {}
            }))
                .then(() => {
                    dispatch(accounts.list({
                        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`, entity: 'accounts', jsonData: {}
                    }))
                }).then(() => {
                    dispatch(vehicles.list({
                        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`, entity: 'vehicles', jsonData: {

                        }
                    }))
                }).then(() => {
                    dispatch(orders.list({
                        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {

                        }
                    }))
                }).then(() => {
                    dispatch(agents.list({
                        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {

                        }
                    }))
                }).then(() => {
                    if (parmas?.id > 0) {
                        fetchAgentQueryById()
                        setIsLoading(false)
                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedAgents(AgentQuery?.result?.items)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        if (parmas?.id > 0) {
            await dispatch(agents.resetAction({ actionType: 'update' }))
            await dispatch(agents.update({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents`, entity: 'agents', jsonData: {

                    Records: [
                        selectedAgents

                    ]
                }
            })).then(() => {
                back()
            })

        } else if (selectedAccounts?.LoginInfo?.Password === selectedAccounts?.LoginInfo?.ConfirmPassword) {
            selectedAccounts.UserInfo.Salutation = 0
            let accountTypes = _.find(accountTypeItems.result.items, ['Name', 'TransportAgent']);
            selectedAccounts.AccountInfo.Name = `${selectedAccounts?.UserInfo?.FirstName} ${selectedAccounts?.UserInfo?.LastName}`
            selectedAccounts.AccountInfo.TypeId = 240 //accountTypes.Id
            selectedAccounts.AccountInfo.IsPersonAccount = false
            selectedAccounts.AccountInfo.MappedAccountTypes.MappedAccountTypeIds = [accountTypes.Id]
            selectedAccounts.AccountAddress.PrimaryAddress = selectedAccounts?.PrimaryAddress
            selectedAccounts.AccountAddress.PrimaryAddress.FaxNumber = selectedAccounts?.LoginInfo.PhoneNumber
            selectedAccounts.AccountAddress.PrimaryAddress.GeocodeAccuracy = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Latitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Longitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.OpeningHoursTypeId = 30,
                selectedAccounts.AccountAddress.IsUsePrimaryAddressAsBillingAddress = true
            selectedAccounts.AccountAddress.IsUsePrimaryAddressAsShippingAddress = true
            selectedAccounts.AccountAddress.BillingAddress = {}
            selectedAccounts.AccountAddress.ShippingAddress = {}
            const data = _.omit(selectedAccounts, 'PrimaryAddress');
            await dispatch(accounts.resetAction({ actionType: 'create' }))
            await dispatch(accounts.create({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts`, entity: 'accounts', jsonData: {

                    Records: [
                        {
                            Context: {},
                            Message: data

                        }
                    ]

                }
            })).then(() => {
                back()
            })
        } else {
            toast.error("Password and Confirm Password must be same.")
        }

    }

    const back = () => {
        navigate('/management/logistics/transport/transport-agents')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <AgentComponent
                    selectedAccounts={selectedAccounts}
                    handleInnerFormChange={handleInnerFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    accounts={accountItems?.result?.items}
                    vehicles={vehicleItems?.result?.items}
                    salesOrders={salesOrderItems?.result?.items}
                    transportAgents={transportAgentItems?.result?.items}
                    selectedAgents={selectedAgents}
                />
            }

        </>
    )

}

export default ManagementAgent;